module.exports = __webpack_public_path__ + "static/media/office_2@2x.4868b0e1.jpg";